<script>
  let { status = "", class: className = "" } = $props();

  const colors = {
    active: "bg-lime-500/15 text-lime-400 border-lime-500/30",
    revoked: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    pending: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    healthy: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    error: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    warning: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    inactive: "bg-white/[0.06] text-zinc-400 border-white/10",
    disabled: "bg-white/[0.06] text-zinc-400 border-white/10",
  };

  let colorClass = $derived(colors[status] || "bg-white/[0.06] text-zinc-400 border-white/10");
</script>

<span class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border {colorClass} {className}">
  {status}
</span>
